export default __webpack_public_path__ + "static/assets/0c0d18bdf2e062e10ac26c2d7350d516.svg";